export enum AffiliateSection {
  Welcome,
  Identification,
  Receive,
}
